// extracted by mini-css-extract-plugin
module.exports = {"tab":"__tab__Xix1r","pinned":"__pinned__p8Vzz","tab-container-scroller":"__tab-container-scroller__ZWbqR","tab-container":"__tab-container__pvGAa"};